module.exports = __webpack_public_path__ + "img/2-polaroid.111940e.png";


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/assets/2-polaroid.png
// module id = 6Cv6
// module chunks = 1